import { render, staticRenderFns } from "./VotingStatsView.vue?vue&type=template&id=45de90bf&"
import script from "./VotingStatsView.vue?vue&type=script&lang=ts&"
export * from "./VotingStatsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports